export const selectRentTermsFilter = () => ({
  label: 'Условия сделки',
});
